/**
 * Écriture refusée par le mode démo (lecture seule stricte, décision du 2026-07-05).
 *
 * Le refus n'est PAS une panne : les valeurs affichées en mode démo sont fictives, les
 * enregistrer les écrirait dans les vraies données. L'erreur porte un code pour qu'une vue
 * puisse le dire (« mode démo : rien n'a été enregistré ») au lieu d'afficher son message
 * d'échec générique.
 */
export const DEMO_WRITE_BLOCKED = "demo/write-blocked";

export const createDemoWriteBlockedError = (message) => Object.assign(new Error(message), { code: DEMO_WRITE_BLOCKED });

export const isDemoWriteBlockedError = (error) => error?.code === DEMO_WRITE_BLOCKED;
